module.exports = __webpack_public_path__ + "static/media/app_escolha_seu_destino_titan.e966873b.png";